var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndpoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_8403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82822 4.98372C6.83433 4.98372 5.21797 6.60008 5.21797 8.59397C5.21797 10.5879 6.83433 12.2042 8.82822 12.2042C10.8221 12.2042 12.4385 10.5879 12.4385 8.59397C12.4385 6.60008 10.8221 4.98372 8.82822 4.98372ZM3.91797 8.59397C3.91797 5.88211 6.11636 3.68372 8.82822 3.68372C11.5401 3.68372 13.7385 5.88211 13.7385 8.59397C13.7385 11.3058 11.5401 13.5042 8.82822 13.5042C6.11636 13.5042 3.91797 11.3058 3.91797 8.59397Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66894 1.93971C8.67055 2.05129 8.58051 2.14229 8.46897 2.14567C7.66788 2.16995 6.89162 2.33828 6.15876 2.64924C5.3897 2.97363 4.699 3.44017 4.10489 4.03246C3.51079 4.62474 3.04607 5.31544 2.71986 6.08268C2.38271 6.87725 2.21322 7.72103 2.21322 8.59397C2.21322 9.46691 2.38453 10.3107 2.71986 11.1053C3.04425 11.8725 3.51079 12.5632 4.10489 13.1555C4.699 13.7478 5.3897 14.2143 6.15876 14.5387C6.89239 14.8486 7.67666 15.0192 8.47154 15.0426C8.58209 15.0458 8.67188 15.1351 8.67188 15.2457V16.2304C8.67188 16.3408 8.58174 16.4306 8.47132 16.4279C4.25926 16.3222 0.871242 12.8991 0.828185 8.67416C0.785111 4.3793 4.17986 0.876286 8.45362 0.760499C8.5631 0.757532 8.6531 0.845656 8.65469 0.955168L8.66894 1.93971Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46648 8.3506C7.29989 8.47031 7.29989 8.71815 7.46647 8.83785L9.80804 10.5205C10.0065 10.6631 10.2831 10.5212 10.2831 10.2768V9.24988L16.6818 9.24988C16.762 9.24988 16.8276 9.18427 16.8276 9.10408V8.08353C16.8276 8.00334 16.762 7.93773 16.6818 7.93773L10.2831 7.93773V6.91162C10.2831 6.66721 10.0065 6.52537 9.80804 6.66799L7.46648 8.3506Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_8403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16.8276 0.593994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpoints);
export default __webpack_public_path__ + "static/media/Endpoints.c580a536457ec4d9573e73e25cc140c1.svg";
export { ForwardRef as ReactComponent };